import React, { use } from 'react';
import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/site-img/logo.png';
import { useAuth } from '../contexts/AuthContext';
import httpService  from '../api/httpService';

const Navbar = ({ toggleSidebar, sidebarOpen }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { userDetails, logout } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState({});

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const result = await httpService.getData(`/User/${userDetails.userid}`);
      setData(result.retObject);
      console.log("For user details", result.retObject);
    }
    fetchData();
    
  }, [userDetails]);

  return (
    <nav className="navbar navbar-expand-lg navbar-light shadow-sm">
      <div className="container-fluid">
        <button className="btn toggle-btn me-3" onClick={toggleSidebar} aria-label="Toggle sidebar">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="#002469">
            <path d={sidebarOpen ? "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" : "M3 6h18v2H3V6zm0 5h18v2H3v11zm0 7h18v2H3v-2z"}/>
          </svg>
        </button>
        <h1 className="navbar-brand mb-0"><img src={logo} alt="" style={{height: '50px'}}/></h1>
        {/* <div className="ms-auto d-flex align-items-center me-3">
          <span className="me-2">Hello, Username</span>
          <svg className="person-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
          </svg>
        </div> */}
        <div className="ms-auto d-flex align-items-center me-3 position-relative" ref={dropdownRef}>
          <span className="me-2 user-greeting cursor-pointer"
            onClick={() => setIsOpen(!isOpen)} style={{ cursor: 'pointer' }}
          >
            {/* Hello, {userDetails?.loginid ?? 'User'} */}
            Hello, {`${data?.firstname} ${data?.lastname}` ?? 'User'}
          </span>
          <i className="fa-solid fa-xl fa-circle-user person-icon cursor-pointer" onClick={() => setIsOpen(!isOpen)}></i>
          {isOpen && (
            <div className="user-dropdown position-absolute top-100 end-0 mt-2 bg-white border shadow-lg rounded p-2" style={{ minWidth: '160px', zIndex: 1000 }}>
              <a href="/profile" className="dropdown-item d-block py-1 px-3 text-decoration-none text-dark rounded hover-bg-light" onClick={() => navigate('/profile')}>
                <i className="fa-solid fa-user me-2"></i>Profile
              </a>
              <a href="" className="dropdown-item d-block py-1 px-3 text-decoration-none text-dark rounded hover-bg-light mt-1" onClick={() => logout(navigate)}>
                <i className="fa-solid fa-circle-exclamation me-2"></i>Logout
              </a>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;